const activity = [{
	//活動管理 - 管理
	path: "activity",
	name: "AdminActivity",
	meta: {
		permission: 18001,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: null
		}, {
			key: 'admin.activity.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/index.vue"),
}, {
	//活動管理 - 新增
	path: "activity/create",
	name: "AdminActivityCreate",
	meta: {
		permission: 18002,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.create',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/form.vue"),
}, {
	//活動管理 - 複製（以來源活動預填新增表單，權限同新增）
	path: "activity/copy/:uuid",
	name: "AdminActivityCopy",
	meta: {
		permission: 18002,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.create',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/form.vue"),
}, {
	//活動管理 - 編輯
	path: "activity/edit/:uuid",
	name: "AdminActivityEdit",
	meta: {
		permission: 18004,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.edit.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/form.vue"),
}, {
	//活動管理 - 編輯 - 後台報名
	path: "activity/edit/:uuid/register",
	name: "AdminActivityEditRegister",
	meta: {
		permission: 18004,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.edit.index',
			value: "AdminActivityEdit"
		}, {
			key: 'admin.activity.edit.register.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/register/create.vue"),
}, {
	//活動管理 - 編輯 - 報名清單
	path: "activity/edit/:uuid/registered",
	name: "AdminActivityEditRegistered",
	meta: {
		permission: 18004,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.edit.index',
			value: "AdminActivityEdit"
		}, {
			key: 'admin.activity.edit.registered.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/registered/index.vue"),
}, {
	//活動管理 - 編輯 - 報名清單 - 內容
	path: "activity/edit/:uuid/registered/edit/:uid?",
	name: "AdminActivityEditRegisteredEdit",
	meta: {
		permission: 18004,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.edit.index',
			value: "AdminActivityEdit"
		}, {
			key: 'admin.activity.edit.registered.index',
			value: "AdminActivityEditRegistered"
		}, {
			key: 'admin.activity.edit.registered.edit.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/registered/edit.vue"),
}, {
	//活動管理 - 編輯 - 報到名單（活動開啟掃碼報到時，內容頁側欄與報名清單頁才有入口）
	path: "activity/edit/:uuid/checkin",
	name: "AdminActivityEditCheckin",
	meta: {
		permission: 18004,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: "AdminActivity"
		}, {
			key: 'admin.activity.edit.index',
			value: "AdminActivityEdit"
		}, {
			key: 'admin.activity.edit.checkin.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/checkin/index.vue"),
}, {
	//活動管理 - 分類管理
	path: "activity/category",
	name: "AdminActivityCategory",
	meta: {
		permission: 18011,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: null
		}, {
			key: 'admin.activity.category.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/category/index.vue"),
}, {
	//活動管理 - 分類新增
	path: "activity/category/create",
	name: "AdminActivityCategoryCreate",
	meta: {
		permission: 18012,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: null
		}, {
			key: 'admin.activity.category.index',
			value: "AdminActivityCategory"
		}, {
			key: 'admin.activity.category.create',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/category/form.vue"),
}, {
	//活動管理 - 分類編輯
	path: "activity/category/edit/:uuid",
	name: "AdminActivityCategoryEdit",
	meta: {
		permission: 18014,
		breadcrumb: [{
			key: 'admin.activity.subject',
			value: null
		}, {
			key: 'admin.activity.category.index',
			value: "AdminActivityCategory"
		}, {
			key: 'admin.activity.category.edit',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/activity/category/form.vue"),
}];

export default activity;
